<script setup lang="ts">
import { tv } from 'tailwind-variants'
import { imageCarouselContentStyles } from './contentStyles'

const theme = useRuntimeConfig().public
  .theme as keyof typeof imageCarouselContentStyles

const styling = tv({
  extend: imageCarouselContentStyles[theme],
})

const { borderRadius } = styling()

interface Props {
  count?: number
  currentIndex: number
  isFullscreen?: boolean
  showDisclaimer?: boolean
  rounded?: boolean
  naturist?: boolean
  gallery?: boolean
}
const contentRef = ref()
defineProps<Props>()
const emits = defineEmits(['next', 'previous', 'toggle-fullscreen'])

defineExpose({
  contentRef,
})
</script>

<template>
  <div ref="contentRef">
    <ImageCarouselFullscreenContent
      v-if="isFullscreen"
      :count="count"
      :show-disclaimer="showDisclaimer"
      :current-index="currentIndex"
      @previous="emits('previous')"
      @next="emits('next')"
      @toggle-fullscreen="emits('toggle-fullscreen')"
    >
      <slot />
    </ImageCarouselFullscreenContent>

    <slot name="gallery" />

    <div
      class="flex relative justify-center items-center overflow-hidden w-full h-full"
      :class="[
        {
          'lg:hidden': gallery,
        },
        rounded ? 'rounded-lg' : borderRadius(),
      ]"
    >
      <slot />

      <div
        v-if="naturist"
        class="text-sm bg-brand-secondary-200 text-brand-secondary-800 p-2 absolute top-0 right-0 rounded-bl"
      >
        {{ $t('site.naturist-campsite') }}
      </div>

      <div class="flex flex-row gap-x-2 self-end absolute p-5 items-center">
        <ImageCarouselPrevious @previous="emits('previous')" />
        <div class="flex flex-row items-center">
          <ImageCarouselCount
            v-if="count"
            :count="count"
            :current-index="currentIndex"
          />

          <ImageCarouselFullscreenControl
            @fullscreen="emits('toggle-fullscreen')"
          />
        </div>

        <ImageCarouselNext @next="emits('next')" />
      </div>
    </div>
  </div>
</template>
